import { render, staticRenderFns } from "./ActiveForms.vue?vue&type=template&id=3cd6647c"
import script from "./ActiveForms.vue?vue&type=script&lang=js"
export * from "./ActiveForms.vue?vue&type=script&lang=js"
import style0 from "./ActiveForms.vue?vue&type=style&index=0&id=3cd6647c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports